import React, { Component } from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { ViewButtonsWrapper, DocCentreContentWrapper, SeparatorBorder } from './styles';
import ToggleSwitch from '../../../CommonComponents/ToggleSwitch/ToggleSwitch';
export class ViewButtonsComponent extends Component {
  render() {
    return (
      <Row data-test="document-centre-view-buttons">
        {
          window.screen.width < 767
            ?
            <Col lg={{ span: 0 }} xs={{ span: 24 }}>
              <ViewButtonsWrapper>
                <DocCentreContentWrapper marginRight='15px' ml="20px">View</DocCentreContentWrapper>
                <ToggleSwitch id={this.props.id} filterType={!this.props.viewButtonValue ? 'List' : 'Grid'} changeState={this.props.handleViewButtonClick} />
              </ViewButtonsWrapper>
            </Col>
            :
            <Col lg={{ span: 24 }} xs={{ span: 0 }}>
              <ViewButtonsWrapper>
                <SeparatorBorder marginLeft="50px" marginRight="50px" height="40px" />
                <DocCentreContentWrapper marginRight='15px'>View</DocCentreContentWrapper>
                <ToggleSwitch id={this.props.id} filterType={!this.props.viewButtonValue ? 'List' : 'Grid'} changeState={this.props.handleViewButtonClick} />
              </ViewButtonsWrapper>
            </Col>
        }


      </Row>
    )
  }
}

ViewButtonsComponent.propTypes = {
  id: PropTypes.string,
  viewButtonValue: PropTypes.bool,
  handleViewButtonClick: PropTypes.func.isRequired,
}

export default ViewButtonsComponent;